import get from "lodash/fp/get";
import useFetch from "~/lib/hooks/useFetch";
import { ReactElement } from "react";

interface IChildProps {
  coordinates: {
    lat: number;
    lng: number;
  } | null;
  error: string | null;
  loading: boolean;
}

interface IGeocodeProps {
  location: string;
  children: (props: IChildProps) => ReactElement | null;
}

export default function Geocode({ location, children }: IGeocodeProps) {
  const { response, error, loading } = useFetch(
    `https://maps.google.com/maps/api/geocode/json?key=${process.env.GOOGLE_MAPS_API_KEY}&address=${encodeURIComponent(
      location,
    )}`,
  );

  const coordinates = get(["results", 0, "geometry", "location"], response);

  return children({ coordinates, error, loading });
}
